<template>
    <v-container>
        <v-layout
                wrap
        >
        <v-flex xs12 md5 lg4>
            <img :src="imageUrl + 'gallery/' + descriptorImage" height="210" class="curved-image">
        </v-flex>
        <v-flex xs12 md8 lg8>
            <v-layout v-for="description in descriptors"><h2>-{{description.descriptor}}</h2></v-layout>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { sync } from 'vuex-pathify';
    const axios = require('axios');

    export default {
        name: 'Description',
        computed: {
            ...sync(['descriptorImage', 'descriptors', 'serviceUrl', 'imageUrl',
                'serviceEndpoints.GET_DESCRIPTORS'])
        },
        mounted: function () {
            let me = this;
            if ((this.descriptors === undefined) || (this.descriptors === null)  || (this.descriptors.length === 0)) {
                axios.get(this.serviceUrl + this.GET_DESCRIPTORS)
                    .then(function (response) {
                        me.descriptors = response.data.payload;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style>
    .curved-image {
        border-radius: 10px;
    }
</style>
